import React, {useState} from 'react';
import {default as text} from '../translate/lang.json';
import {useRecoilValue} from 'recoil';
import {langState} from '../state/activities';

const Section = ({title, children}: {title: string; children: React.ReactNode}) => {
  const [open, setOpen] = useState(true);
  return (
    <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between px-5 py-4 text-left hover:bg-gray-50 transition-colors"
      >
        <span className="text-[15px] font-semibold text-gray-800">{title}</span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className={`w-4 h-4 text-gray-400 transition-transform duration-200 ${open ? 'rotate-180' : ''}`}
          fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
        </svg>
      </button>
      {open && (
        <div className="px-5 pb-4 text-sm text-gray-600 leading-relaxed border-t border-gray-100 pt-3">
          {children}
        </div>
      )}
    </div>
  );
};

const PageHelp = () => {
  const lang = useRecoilValue(langState);
  return (
    <div className="max-w-3xl mx-auto py-8 px-4 space-y-5">
      <h1 className="font-bold text-black-accent text-3xl mb-2">{text.start_help[lang]}</h1>

      <Section title={text.import_button[lang]}>
        {text.help_import_desc[lang]}
      </Section>

      <Section title={text.header[lang]}>
        {text.help_activity_desc[lang]}
      </Section>

      <Section title={text.stat_title[lang]}>
        {text.help_stats_desc[lang]}
      </Section>

      <Section title={text.help_hvb_title[lang]}>
        <p className="mb-3">{text.help_hvb_desc[lang]}</p>
        <ul className="list-disc pl-5 space-y-1.5">
          <li>{text.help_hvb_graph[lang]}</li>
          <li>{text.help_hvb_rulers[lang]}</li>
          <li>{text.help_hvb_stats[lang]}</li>
        </ul>
      </Section>
    </div>
  );
};

export default PageHelp;
